import { useState } from "react"

import {
  Box,
  Button,
  Flex,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react"

import ProductImage from "./ProductImage"

const ProductList = ({ items, cart, setCart }) => {
  return (
    <Tabs align="center">
      <TabList>
        <Tab>Fresco</Tab>
        <Tab>Gastronomia</Tab>
        <Tab>Mostarde</Tab>
      </TabList>

      <TabPanels>
        <TabPanel>
          {items.filter((product) => product.category === "fresco").length >
          0 ? (
            <ProductListTab
              items={items.filter((product) => product.category === "fresco")}
              cart={cart}
              setCart={setCart}
            />
          ) : (
            <Text>I nostri prodotti freschi arriveranno a breve</Text>
          )}
        </TabPanel>
        <TabPanel>
          <ProductListTab
            items={items.filter((product) => product.category === "gastro")}
            cart={cart}
            setCart={setCart}
          />
        </TabPanel>
        <TabPanel>
          <ProductListTab
            items={items.filter((product) => product.category === "mostarde")}
            cart={cart}
            setCart={setCart}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}

const QuantitySelect = ({ value, setValue }) => {
  return (
    <Stack spacing={2} direction="row" w="full" justify="center">
      {[1, 2, 3, 4, 5, 6, 7, 8].map((qty) => (
        <Button
          key={qty}
          variant={value === qty ? "solid" : "outline"}
          colorScheme={value === qty ? "teal" : "teal"}
          borderRadius="50%"
          fontSize="xs"
          borderWidth="1px"
          borderColor={value === qty ? "transparent" : "teal"}
          onClick={() => setValue(value === qty ? 0 : qty)}
          size="xs"
          lineHeight={1}
          d="flex"
          alignItems="center"
          justifyContent="center"
        >
          <span>{qty}</span>
        </Button>
      ))}
    </Stack>
  )
}

const ProductListItem = ({ item, onQuantityChange }) => {
  const [quantity, setQuantity] = useState()

  return (
    <Flex
      // borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      // direction={["column", "row"]}
      direction="column"
      bg="gray.100"
      // bg="#f4f0e6"
    >
      <ProductImage src={item.image} width="full" />

      <Stack p="6" spacing={4}>
        <Box
          mt="1"
          fontWeight="semibold"
          as="h4"
          lineHeight="tight"
          // isTruncated
        >
          {item.name}
        </Box>

        <Box>
          <Text color="gray.600" fontSize="sm">
            {`Prezzo: ${item.price} €`}
          </Text>
          <Text color="gray.600" fontSize="sm">
            {item.description}
          </Text>
        </Box>
        <QuantitySelect
          value={quantity}
          setValue={(value) => {
            onQuantityChange(item, value)
            setQuantity(value)
          }}
        />
      </Stack>
    </Flex>
  )
}

const ProductListTab = ({ items, cart, setCart }) => {
  return (
    <Stack spacing={4}>
      {items.map((item) => (
        <ProductListItem
          key={item.id}
          item={item}
          onQuantityChange={(item, qty) => {
            if (qty === 0) {
              let tmp = { ...cart }
              delete tmp[item.id]
              setCart({ ...tmp })
            } else {
              setCart({
                ...cart,
                [item.id]: {
                  id: item.id,
                  name: item.name,
                  price: item.price,
                  category: item.category,
                  qty,
                },
              })
            }
          }}
        />
      ))}
    </Stack>
  )
}

export default ProductList
